// Guard so this file can also load standalone (e.g. the gift redemption funnel
// reuses DOG_BREEDS). In bb-funnel-v2 window.SubscriptionFunnel is already set
// before this script, so this assignment is a no-op there.
window.SubscriptionFunnel = window.SubscriptionFunnel || {};

window.SubscriptionFunnel.StepBreed = {
  DOG_BREEDS: [
    "Other",
    "Yorkshire Terrier",
    "Wirehaired Vizsla",
    "Wirehaired Pointing Griffon",
    "White Shepherd",
    "Whippet",
    "Wetterhoun",
    "Westphalian Dachsbracke",
    "West Siberian Laika",
    "West Highland White Terrier",
    "Welsh Terrier",
    "Welsh Springer Spaniel",
    "Welsh Sheepdog",
    "Welsh Corgi, Pembroke",
    "Welsh Corgi, Cardigan",
    "Weimaraner",
    "Volpino Italiano",
    "Vizsla",
    "Villano de Las Encartaciones",
    "Vanjari Hound",
    "Uruguayan Cimarron",
    "Tyrolean Hound",
    "Tweed Water Spaniel",
    "Trigg Hound",
    "Treeing Walker Coonhound",
    "Treeing Cur",
    "Transylvanian Hound",
    "Toy Trawler Spaniel",
    "Toy Manchester Terrier",
    "Toy Fox Terrier",
    "Toy Bulldog",
    "Tosa",
    "Tornjak",
    "Tibetan Terrier",
    "Tibetan Spaniel",
    "Tibetan Mastiff",
    "Thai Ridgeback",
    "Thai Bangkaew Dog",
    "Terceira Mastiff",
    "Tenterfield Terrier",
    "Tennessee Treeing Brindle",
    "Telomian",
    "Teddy Roosevelt Terrier",
    "Tamaskan Dog",
    "Talbot",
    "Taigan",
    "Tahltan Bear Dog",
    "Swedish Vallhund",
    "Swedish Lapphund",
    "Sussex Spaniel",
    "Styrian Coarse-haired Hound",
    "Stephens Cur",
    "Staffordshire Bull Terrier",
    "Stabyhoun",
    "St. John's water dog",
    "St. Bernard",
    "Sporting Lucas Terrier",
    "Spinone Italiano",
    "Spanish Water Dog",
    "Spanish Mastiff",
    "Boxerdoodle, mini",
    "South Russian Ovcharka",
    "Soft-Coated Wheaten Terrier",
    "Small Greek Domestic Dog",
    "Smålandsstövare",
    "Slovenský Kopov",
    "Slovakian Rough-haired Pointer",
    "Slovak Cuvac",
    "Sloughi",
    "Skye Terrier",
    "Sinhala Hound",
    "Silken Windhound",
    "Siberian Husky",
    "Shiloh Shepherd Dog",
    "Shikoku",
    "Shih Tzu",
    "Shiba Inu",
    "Shetland Sheepdog",
    "Shar Pei",
    "Seskar Seal Dog",
    "Serbian Tricolour Hound",
    "Serbian Hound",
    "Seppala Siberian Sleddog",
    "Segugio Italiano",
    "Sealyham Terrier",
    "Scottish Terrier",
    "Scottish Deerhound",
    "Scotch Collie",
    "Schweizerischer Niederlaufhund",
    "Schweizer Laufhund",
    "Irish Doodle, Mini",
    "Schipperke",
    "Schillerstövare",
    "Schapendoes",
    "Šarplaninac",
    "Sapsali",
    "Santal Hound",
    "Samoyed",
    "Saluki",
    "Sakhalin Husky",
    "Saint-Usuge Spaniel",
    "Sabueso Español",
    "Saarlooswolfhond",
    "Russell Terrier",
    "Russo-European Laika",
    "Russian tracker",
    "Russian Toy",
    "Russian Spaniel",
    "Rottweiler",
    "Rhodesian Ridgeback",
    "Redbone Coonhound",
    "Rat Terrier",
    "Ratonero Valenciano",
    "Ratonero Bodeguero Andaluz",
    "Rastreador Brasileiro",
    "Rampur Greyhound",
    "Rajapalayam",
    "Rafeiro do Alentejo",
    "Pyrenean Shepherd",
    "Pyrenean Mastiff",
    "Pungsan Dog",
    "Pumi",
    "Puli",
    "Pug",
    "Pudelpointer",
    "Pražský Krysařík",
    "Posavac Hound",
    "Portuguese Water Dog",
    "Portuguese Pointer",
    "Portuguese Podengo",
    "Porcelaine",
    "Poodle",
    "Pont-Audemer Spaniel",
    "Pomeranian",
    "Polish Tatra Sheepdog",
    "Polish Lowland Sheepdog",
    "Polish Hunting Dog",
    "Polish Hound",
    "Polish Greyhound",
    "Poitevin",
    "Pointer",
    "Podenco Canario",
    "Plott Hound",
    "Picardy Spaniel",
    "Phu Quoc ridgeback dog",
    "Pharaoh Hound",
    "Phalène",
    "Peruvian Hairless Dog",
    "Perro de Presa Mallorquin",
    "Perro de Presa Canario",
    "Pekingese",
    "Patterdale Terrier",
    "Parson Russell Terrier",
    "Papillon",
    "Paisley Terrier",
    "Pandikona",
    "Pachon Navarro",
    "Otterhound",
    "Olde English Bulldogge",
    "Old Time Farm Shepherd",
    "Old German Shepherd Dog",
    "Bernoodle, Tiny",
    "Old English Sheepdog",
    "Old Danish Pointer",
    "Old Croatian Sighthound",
    "Nova Scotia Duck-Tolling Retriever",
    "Norwich Terrier",
    "Norwegian Lundehund",
    "Norwegian Elkhound",
    "Norwegian Buhund",
    "Northern Inuit Dog",
    "Boxerdoodle, standard",
    "Norrbottenspets",
    "Norfolk Terrier",
    "Norfolk Spaniel",
    "New Zealand Heading Dog",
    "Newfoundland",
    "Neapolitan Mastiff",
    "Münsterländer, Small",
    "Münsterländer, Large",
    "Mudi",
    "Mudhol Hound",
    "Mucuchies",
    "Mountain Cur",
    "Moscow Water Dog",
    "Moscow Watchdog",
    "Montenegrin Mountain Hound",
    "Molossus",
    "Mioritic",
    "Miniature Shar Pei",
    "Goldendoodle, Mini/Medium",
    "Goldendoodle, Toy",
    "Miniature Fox Terrier",
    "Miniature American Shepherd",
    "Miniature Australian Shepherd",
    "Irish Doodle, Standard",
    "McNab",
    "Maremma Sheepdog",
    "Manchester Terrier",
    "Maltese",
    "Majorca Shepherd Dog",
    "Mahratta Greyhound",
    "Magyar Agár",
    "Löwchen",
    "Longhaired Whippet",
    "Lithuanian Hound",
    "Lhasa Apso",
    "Leonberger",
    "Lapponian Herder",
    "Landseer",
    "Lancashire Heeler",
    "Lakeland Terrier",
    "Lagotto Romagnolo",
    "Labrador Retriever",
    "Kyi-Leo",
    "Kuvasz",
    "Kurī",
    "Kunming Wolfdog",
    "Kumaon Mastiff",
    "Kromfohrländer",
    "Korean Jindo Dog",
    "Koolie",
    "Kooikerhondje",
    "Komondor",
    "Kishu",
    "Kintamani",
    "King Shepherd",
    "Skypoo, Large",
    "Kerry Blue Terrier",
    "Kerry Beagle",
    "Keeshond",
    "Karst Shepherd",
    "Karelian Bear Dog",
    "Karakachan Dog",
    "Kanni",
    "Kangal Dog",
    "Kai Ken",
    "Kaikadi",
    "Japanese Terrier",
    "Japanese Spitz",
    "Japanese Chin",
    "Jämthund",
    "Jagdterrier",
    "Jack Russell Terrier",
    "Italian Greyhound",
    "Istrian Shorthaired Hound",
    "Istrian Coarse-haired Hound",
    "Irish Wolfhound",
    "Irish Water Spaniel",
    "Irish Terrier",
    "Irish Setter",
    "Irish Red and White Setter",
    "Indian Spitz",
    "Indian pariah dog",
    "Icelandic Sheepdog",
    "Ibizan Hound",
    "Hygenhund",
    "Huntaway",
    "Hovawart",
    "Hortaya Borzaya",
    "Hokkaido",
    "Himalayan Sheepdog",
    "Hawaiian Poi Dog",
    "Havanese",
    "Harrier",
    "Hare Indian Dog",
    "Hanover Hound",
    "Hamiltonstövare",
    "Guatemalan Dogo",
    "Griffon Nivernais",
    "Griffon Fauve de Bretagne",
    "Griffon Bruxellois",
    "Griffon Bleu de Gascogne",
    "Greyhound",
    "Greenland Dog",
    "Greek Harehound",
    "Greater Swiss Mountain Dog",
    "Great Pyrenees",
    "Great Dane",
    "Grand Griffon Vendéen",
    "Grand Anglo-Français Tricolore",
    "Grand Anglo-Français Blanc et Orange",
    "Grand Anglo-Français Blanc et Noir",
    "Gran Mastín de Borínquen",
    "Gordon Setter",
    "Golden Retriever",
    "Glen of Imaal Terrier",
    "Bernedoodle, Miniature",
    "German Wirehaired Pointer",
    "German Spitz",
    "German Spaniel",
    "German Shorthaired Pointer",
    "German Shepherd Dog",
    "German Rough-haired Pointer",
    "German Pinscher",
    "German Longhaired Pointer",
    "Georgian Shepherd Dog",
    "Gascon Saintongeois",
    "Garafía Shepherd Dog",
    "Galician Cattle Dog",
    "Galgo Español",
    "Gaddi Dog",
    "French Spaniel",
    "French Bulldog",
    "French Brittany",
    "Fox Terrier, Wire",
    "Fox Terrier (Smooth)",
    "Formosan Mountain Dog",
    "Flat-Coated Retriever",
    "Finnish Spitz",
    "Finnish Lapphund",
    "Finnish Hound",
    "Fila Brasileiro",
    "Field Spaniel",
    "Eurasier",
    "Estrela Mountain Dog",
    "Estonian Hound",
    "Épagneul Bleu de Picardie",
    "Entlebucher Mountain Dog",
    "English White Terrier",
    "English Water Spaniel",
    "English Toy Terrier (Black and Tan)",
    "English Springer Spaniel",
    "English Shepherd",
    "English Setter",
    "English Mastiff",
    "English Foxhound",
    "American English Coonhound",
    "English Cocker Spaniel",
    "Elo",
    "East-European Shepherd",
    "East Siberian Laika",
    "Dutch Smoushond",
    "Dutch Shepherd Dog",
    "Dunker",
    "Drever",
    "Drentse Patrijshond",
    "Dogue de Bordeaux",
    "Dogo Cubano",
    "Dogo Argentino",
    "Doberman Pinscher",
    "Deutsche Bracke",
    "Decker Rat Terrier",
    "Danish Swedish Farmdog",
    "Dandie Dinmont Terrier",
    "Dalmatian",
    "Dachshund",
    "Czechoslovak Wolfdog",
    "Cursinu",
    "Curly Coated Retriever",
    "Cumberland Sheepdog",
    "Croatian Sheepdog",
    "Cretan Hound",
    "Coton de Tulear",
    "Cordoba Fighting Dog",
    "Combai",
    "Collie, Smooth",
    "Collie, Rough",
    "Cirneco dell'Etna",
    "Cierny Sery",
    "Chow Chow",
    "Chippiparai",
    "Chinook",
    "Chinese Imperial Dog",
    "Chinese Crested Dog",
    "Chinese Chongqing Dog",
    "Chilean Fox Terrier",
    "Chihuahua",
    "Chien-gris",
    "Chien Français Tricolore",
    "Chien Français Blanc et Orange",
    "Chien Français Blanc et Noir",
    "Chesapeake Bay Retriever",
    "Cesky Terrier",
    "Cesky Fousek",
    "Central Asian Shepherd Dog",
    "Cavalier King Charles Spaniel",
    "Caucasian Shepherd Dog",
    "Catalan Sheepdog",
    "Aussiedoodle, Small or Mini",
    "Carpathian Shepherd Dog",
    "Carolina Dog",
    "Cão Fila de São Miguel",
    "Cão de Castro Laboreiro",
    "Cão da Serra de Aires",
    "Cantabrian Water Dog",
    "Cane Corso",
    "Canadian Eskimo Dog",
    "Canaan Dog",
    "Cairn Terrier",
    "Burgos Pointer",
    "Bully Kutta",
    "Bullmastiff",
    "Bullenbeisser",
    "Bulldog",
    "Cavapoo, Miniature",
    "Bull Terrier",
    "Labradoodle, Medium",
    "Bucovina Shepherd Dog",
    "Bruno Jura Hound",
    "Broholmer",
    "Brittany",
    "Briquet Griffon Vendéen",
    "Briard",
    "Brazilian Terrier",
    "Brazilian Dogo",
    "Braque Saint-Germain",
    "Braque Francais",
    "Braque du Puy",
    "Braque du Bourbonnais",
    "Braque d'Auvergne",
    "Bracco Italiano",
    "Boykin Spaniel",
    "Boxer",
    "Bouvier des Flandres",
    "Bouvier des Ardennes",
    "Boston Terrier",
    "Bosnian Coarse-haired Hound",
    "Borzoi",
    "Border Terrier",
    "Border Collie",
    "Bolognese",
    "Bohemian Shepherd",
    "Boerboel",
    "Bluetick Coonhound",
    "Blue Paul Terrier",
    "Blue Lacy",
    "Blue Heeler",
    "Bloodhound",
    "Bleu de Gascogne, Petit",
    "Bleu de Gascogne, Grand",
    "Blackmouth Cur",
    "Black Russian Terrier",
    "Labradoodle, Mini/Toy",
    "Black and Tan Virginia Foxhound",
    "Black and Tan Coonhound",
    "Billy",
    "Bichon Frisé",
    "Bernese Mountain Dog",
    "Berner Laufhund",
    "Berger Picard",
    "Berger Blanc Suisse",
    "Bergamasco Shepherd",
    "Belgian Shepherd (Tervuren)",
    "Belgian Shepherd Dog (Malinois)",
    "Belgian Shepherd Dog (Laekenois)",
    "Belgian Shepherd Dog (Groenendael)",
    "Bedlington Terrier",
    "Beauceron",
    "Bearded Collie",
    "Beagle-Harrier",
    "Beagle",
    "Bavarian Mountain Hound",
    "Basset Hound",
    "Basset Griffon Vendéen, Petit",
    "Basset Griffon Vendéen, Grand",
    "Basset Fauve de Bretagne",
    "Basset Bleu de Gascogne",
    "Basset Artésien Normand",
    "Basque Shepherd Dog",
    "Basque Ratter",
    "Basenji",
    "Barbet",
    "Bakharwal Dog",
    "Azawakh",
    "Austrian Pinscher",
    "Austrian Black and Tan Hound",
    "Australian Terrier",
    "Australian Stumpy Tail Cattle Dog",
    "Australian Silky Terrier",
    "Australian Shepherd",
    "Australian Kelpie",
    "Terrier",
    "Australian Cattle Dog",
    "Artois Hound",
    "Armenian Gampr dog",
    "Armant",
    "Ariegeois",
    "Ariege Pointer",
    "Appenzeller Sennenhund",
    "Anglo-Français de Petite Vénerie",
    "Andalusian Hound",
    "Anatolian Shepherd Dog",
    "American Water Spaniel",
    "American Staffordshire Terrier",
    "American Pit Bull Terrier",
    "American Hairless Terrier",
    "American Foxhound",
    "American Eskimo Dog",
    "American Cocker Spaniel",
    "American Bulldog",
    "American Akita",
    "Alpine Spaniel",
    "Alpine Dachsbracke",
    "Alaskan Malamute",
    "Alaskan Klee Kai",
    "Alano Español",
    "Akita Inu",
    "Akbash",
    "Airedale Terrier",
    "Aidi",
    "Afghan Shepherd",
    "Afghan Hound",
    "Affenpinscher",
    "Cavapoo, Toy",
    "Mutt",
    "Cockapoo",
    "Maltipoo",
    "Poodle, Miniature",
    "Puggle",
    "Schnoodle",
    "Yorkipoo",
    "Skypoo, Medium",
    "Turkish Pointer",
    "Coydog",
    "Hound",
    "Shitzu",
    "English Bulldog",
    "Husky",
    "Mixed Breed",
    "Pit Bull",
    "Affenpoo",
    "Airedoodle",
    "Aussiedoodle",
    "Bassetoodle",
    "Bich-poo",
    "Bolonoodle",
    "Bordoodle",
    "Bossi-poo",
    "Braque d’Auvergne",
    "Cairnoodle",
    "Catahoula Leopard Dog",
    "Chi-poo",
    "Chinese Shar-Pei",
    "Clumberdoodle",
    "Cockerspaniel",
    "Corgipoo",
    "Daisy dog",
    "Dalmadoodle",
    "Doodleman Pinscher",
    "Double Doodle",
    "Doxiepoo",
    "Eng-A-Poo",
    "English Boodle",
    "English Pointer",
    "EskIpoo",
    "Flandoodle",
    "Flatdoodle",
    "Foxhoodle",
    "Great Danoodle",
    "Hokkaido (Ainu Dog)",
    "Irish Troodle",
    "Jackapoo",
    "Medium",
    "Lhasapoo",
    "Newfypoo",
    "Norwegian Hound",
    "Papipoo",
    "Peekapoo",
    "Pomapoo",
    "Poo-shi",
    "Poo-ton",
    "Poochin",
    "Poogle",
    "Pootalian",
    "Pugapoo",
    "Rattle",
    "Rottle",
    "Saint Berdoodle",
    "Schipper-poo",
    "Scoodle",
    "Shar-poo",
    "Sheepadoodle",
    "Sheltidoodle",
    "Shichon",
    "Siberpoo",
    "Chinese Shar-Pei, Miniature",
    "Spoodle",
    "Ttoodle",
    "Weimardoodle",
    "Westiepoo",
    "Whoodle",
    "Wire-poo",
    "Woodle",
    "Schnauzer, Giant",
    "Pinscher, Miniature",
    "Schnauzer, Miniature",
    "Shih-poo",
    "Schnauzer",
    "Bull Terrier, Miniature",
    "Labrador Husky (Labsky)",
    "Bernedoodle, Standard",
    "Mexican Hairless Dog (Xoloitzcuintli), Medium",
    "Norwegian Elkhound, Black",
    "Goldendoodle, Standard",
    "Labradoodle, Standard",
    "Poodle, Standard",
    "Poodle, Toy",
  ],

  showBreedSuggestions(event, breedNumber) {
    const suggestionsBox = document.getElementById(`${breedNumber}-matches`);
    const input = document.getElementById(breedNumber);

    let value = event.target.value;

    // Toggle clear button visibility
    const clearButton = document.querySelector(
      `#${breedNumber}-container .typeahead-component-clear-control`
    );
    if (value.length > 0) {
      clearButton.classList.remove("display-none");
    } else {
      clearButton.classList.add("display-none");
    }

    let filteredBreeds = this.DOG_BREEDS.filter((breed) =>
      breed.toLowerCase().includes(value.toLowerCase())
    );

    // Clear previous suggestions
    suggestionsBox.innerHTML = "";

    if (filteredBreeds.length === 0 || value.trim() === "") {
      filteredBreeds = ["Don't see my dog's breed"];
    }

    // Display filtered suggestions
    filteredBreeds.forEach((breed) => {
      const li = document.createElement("li");
      li.textContent = breed;
      li.tabIndex = "-1";
      li.setAttribute("aria-selected", "false");
      li.setAttribute("role", "option");
      li.addEventListener("click", () => {
        input.value = breed; // Set input value when suggestion clicked
        suggestionsBox.style.display = "none";

        // Show secondary breed input if applicable
        if (breed === "Don't see my dog's breed") {
          return;
        }

        if (breedNumber === "breed1") {
          const secondaryBreedContainer =
            document.getElementById("breed2-container");
          secondaryBreedContainer.classList.remove("display-none");
          // Use document.getElementById to get the secondary input
          document.getElementById("breed2").value = "";
        }
      });
      suggestionsBox.appendChild(li);
    });

    suggestionsBox.style.display = "block";
  },

  clearBreedValue(breedNumber) {
    const input = document.getElementById(breedNumber);
    input.value = "";

    const clearButton = document.querySelector(
      `#${breedNumber}-container .typeahead-component-clear-control`
    );
    clearButton.classList.add("display-none");

    if (breedNumber === "breed1") {
      // Hide secondary breed container and clear its input
      const secondaryBreedContainer =
        document.getElementById("breed2-container");
      secondaryBreedContainer.classList.add("display-none");
      document.getElementById("breed2").value = "";
    }
  },

  validateBreeds() {
    const breed1 = document.getElementById("breed1").value;
    const breed2 = document.getElementById("breed2").value;

    // Combine valid breeds list with the fallback option
    const validBreeds = [...this.DOG_BREEDS, "Don't see my dog's breed"];

    if (breed1) {
      if (!validBreeds.includes(breed1)) {
        document
          .getElementById("breed1")
          .classList.add("text-input-component-input--error");
        document
          .querySelector("div#breed1-container .form-input-text-error-message")
          .classList.remove("display-none");
        return false;
      }
    }

    if (breed2) {
      if (!validBreeds.includes(breed2)) {
        document
          .getElementById("breed2")
          .classList.add("text-input-component-input--error");
        document
          .querySelector("div#breed2-container .form-input-text-error-message")
          .classList.remove("display-none");
        return false;
      }
    }

    SubscriptionFunnel.FunnelNavigation.nextStep();
  },
};

// Hide suggestions when clicking outside
document.addEventListener("click", (event) => {
  const suggestionsBox = document.getElementById("breed1-matches");
  const input = document.getElementById("breed1");

  if (!suggestionsBox.contains(event.target) && event.target !== input) {
    suggestionsBox.style.display = "none";
  }
});

document.addEventListener("click", (event) => {
  const suggestionsBox = document.getElementById("breed2-matches");
  const input = document.getElementById("breed2");

  if (!suggestionsBox.contains(event.target) && event.target !== input) {
    suggestionsBox.style.display = "none";
  }
});
